export default {
  title: 'Order Layout',
  form: {
    show_hero_image_with_offers: {
      label: 'Show hero image with offers',
      description: 'By default, adding an offer image hides the hero image. Enable this to show both.',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
